import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/ba-1-on-1"
    exact
    path="/business/products/ba-1-on-1"
    component={AsyncPage}
  />,
];
